module.exports = __webpack_public_path__ + "img/careers-biscuits.jpg?2fc3a64d0c765fb649e4979c789b8805";